import UploadIcon from "@atlaskit/icon/core/upload";
import {AnankeDropdownItem} from "@vesta/ananke/components/anankeDropdownItem";

export function ExportDataDropdownItem({
    onNativeCsvExport,
    isVisible = true,
}: {
    /** Backend-owned CSV action for rows whose caller has opted into native export. */
    onNativeCsvExport?: () => void;
    /** Hide CSV where the domain action has been explicitly retired. */
    isVisible?: boolean;
}) {
    if (!isVisible || onNativeCsvExport === undefined) {return null;}
    return (
        <AnankeDropdownItem
            onClick={onNativeCsvExport}
            elemBefore={<UploadIcon label="" />}
        >
            Export
        </AnankeDropdownItem>
    );
}
